import { useMutation } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';
import { declineRentalApplicationShare } from '../api-ts';
import type { ShareApplicationPropertyAddress } from '../../models';

export function useDeclineApplicationShare() {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: (params: { shareId: string; message: string; updatedAddress: ShareApplicationPropertyAddress }) =>
      dispatch(declineRentalApplicationShare(params)),
  });
}
